import React from "react";
import { isRunTime } from "src/utils/isRunTime";
import { getLanguageField } from 'src/utils/language';

type SeoProps = {
    data: {
        name: string;
        destination?: {
            name: string;
            favicon?: {
                imageFile: string;
            }
        },
        translations: TTranslations<{
            title: string;
        }>;
    };
    pageContext: {
        isInApp: boolean;
        language: string;
    };
}

export default class SeoV1 extends React.Component<SeoProps> {
    
    private get favicon() {
        const data = this.props.data;
        if(data && data.destination && data.destination.favicon && data.destination.favicon.imageFile) {
            return `https://public-assets.spotliodata.com/${data.destination.favicon.imageFile}`;
        }
        return undefined;
    }
   
    render(): React.ReactNode {
        const favicon = this.favicon;
        const {data, pageContext} = this.props;

        const t_title = getLanguageField(data.translations, pageContext.language, 'title');
        const t_description = getLanguageField(data.translations, pageContext.language, 'description');
        const t_keywords: string[] = (getLanguageField(data.translations, pageContext.language, 'keywords') as string[]) || [];
        
        const t_robots = pageContext.isInApp
            ? 'noindex,nofollow,noarchive'
            : getLanguageField(data.translations, pageContext.language, 'robots');

        const canonicalUrl = isRunTime() ? window.location.origin + window.location.pathname : '';
        return <>
        <title id="mainTitle" key="seo1">{`${t_title || data?.name || ''} | ${data?.destination?.name}`}</title>
        <meta id="metaTitle" property="title" content={`${t_title} | ${data?.destination?.name}`} key="seo2" />
        <meta id="metaOgTitle" property="og:title" content={`${t_title} | ${data?.destination?.name}`} key="seo3" />
        <link rel="canonical" href={canonicalUrl} />

        {typeof t_description === "string" ? <>
        <meta id="metaDescription" name="description" content={t_description} key="seo4" />
        <meta id="metaOgDescription" property="og:description" content={t_description} key="seo5" />
        </> : null}

        {t_keywords.length ? <meta id="metaKeywords" name="keywords" content={t_keywords.join(", ")} key="seo6" /> : null}
        {typeof t_robots === "string" ? <meta id="metaRobots" name="robots" content={t_robots} key="seo7" /> : null}

        {favicon ? <>
        <link rel="icon" type="image/png" href={favicon} key="seo8" />
        <link rel="apple-touch-icon-precomposed" sizes="114x114" href={favicon} key="seo9" />
        <link rel="apple-touch-icon-precomposed" sizes="72x72" href={favicon} key="seo10" />
        <link rel="apple-touch-icon-precomposed" href={favicon} key="seo11" />
        </> : null }

        </>
    }
}
